var Naturali = Naturali || {};

Naturali = function(){
  var init = function() {
    console.log('Welcome to Naturali');
    initCurrencyUpdate();
    initCurrency();
    initLangSwitcher();
    initCustomAddToBag();
    initAccordionList();
    misc();
  };
  
  var misc = function() {
    $('.js-hide').on('click', function(e){
      e.preventDefault();
      $($(this).data('parent')).addClass('hidden');
      return false;
    });

    $('.yotpo.bottomLine').on('click', function(e){
      $('.tab-section li:nth-child(2) a').click();
      $('a[href="#pdp-tab-reviews-collapse"]').click();
    });
  };
  
  var initAccordionList = function(){
    $( ".alist dt" ).on('click', function(){
      $( ".alist dd" ).not($(this).nextUntil( "dt" )).slideUp();
      $( this ).nextUntil( "dt" ).slideToggle();
    });
  };

  
  var initCurrency = function() {
    if(Currency.cookie.read() === null){
      var currency = 'USD';
      if(location.hostname === 'cn.naturali-japan.com'){
        currency = 'CNY';
      }
      if(location.hostname === 'hk.naturali-japan.com'){
        currency = 'HKD';
      }
      $('#currencies').val(currency).trigger('change');
    }
  };
  
  var initCurrencyUpdate = function(){
    $(document).on('site.currencyUpdate', function(){
      Currency.convertAll(defaultCurrency, Currency.currentCurrency);
    });
  };
  
  var initLangSwitcher = function(){
    $('.lang-opt').on('click', function(){
        fireLangChange( $(this).data('value') );
    });
    $('.header-lang').on('change', function(){
      if ( $(this).val().indexOf('https') == -1 ) {
        fireLangChange( $(this).val() );
      } else {
        location.href = $(this).val();
      }
    });
    $('.js-lang-opt-dropdown').on('change', function(){
        fireLangChange( $(this).val() );
    });
  };

  var fireLangChange = function( langCode ) {
    $('.ly-languages-switcher').val( langCode ).change();
  };
  
  var updateCartCount = function(cart) {
    $cartBtn = $(".cart_button");
    if ($cartBtn) {
      var $cartCount = $cartBtn.find('.cart_count');
      if ($cartCount.length) {
        $cartCount.text(cart.item_count);
      }
    }
  };
  
  var setAddToBagLoading = function($addToCartBtn){
    $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
    $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
  };
  
  var setAddToBagSuccess = function($addToCartBtn){
    $addToCartBtn.find('span')
    	.text("Added")
    	.removeClass('zoomOut').addClass('fadeIn');
  };
  
  var setAddToBagReset = function($addToCartBtn){
    $('.js-add-to-cart-submit').each(function(){
      $(this).removeClass('disabled').attr('disabled',false).find('span')
    	.text($(this).data('label'))
    	.removeClass('zoomOut').addClass('fadeIn');
    });
  };
  
  var initCustomAddToBag = function(){
    // disable original add to bag behavior
    $(document).off('click', '.ajax-submit');
    
    
    $(document).on('click', '.ajax-submit', function(e){
      
      var $addToCartForm = $(this).closest('form');
      var $addToCartInfo = $(this).parent('.product_form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      var isCheckout = $(this).data('buy-now');
      var $submitForm = $(this);
      
      Naturali.globalVal.checkoutDeferredObj = $.Deferred();
      
      if ( isCheckout ) {
        
        Naturali.globalVal.checkoutDeferredObj.done(function(){
          location.href='/checkout';
        });
        Naturali.globalVal.checkoutDeferredObj.fail(function(msg){
          console.log(msg);
        });
      } else {
        Naturali.globalVal.checkoutDeferredObj.done(function(){});
      }
      
      // change add-to-bag CTA state
      setAddToBagLoading($addToCartBtn);
      var formMode = $addToCartForm.find('.submit-mode').val();
      
      switch( formMode ){
        case 'multiple':
        case 'multiple1-10':
      
          // prepare data
          var optSize = $addToCartForm.find('.purchase-details').data('size'),
              variantId = '',
              queueForAdd = [],
              qty = parseInt($addToCartForm.find('.js-product-qty').val()),
              addQty = 1;

          if(qty > 1) {
            addQty = qty / 2;
          }
          if ( formMode == 'multiple1-10' ) {
            addQty = qty;
          }
          console.log("qty:"+qty);
          console.log("addQty:"+addQty);
          // add left diopter
          var valTitle = [];
          for(var i=0;i<optSize;i++){
            console.log('1. pdp-option-'+i+': '+$addToCartForm.find('.pdp-option-'+i).val());
            valTitle.push($addToCartForm.find('.pdp-option-'+i).val());
          };

          variantId = $addToCartForm.find('.pdp-variants-list option[data-title="'+valTitle.join(' / ')+'"]').val();      
          console.log('variantId: ' + variantId);
          queueForAdd.push({variantId: variantId, qty: addQty});

//           console.log('queueForAdd:');
//           console.log(queueForAdd);
          
          // add right diopter
          if ( qty > 1 && formMode != 'multiple1-10') {
            valTitle = [];
            for(var i=0;i<optSize;i++){
              var optionId = 'pdp-option-' + i;
              var $optionObj = $addToCartForm.find('.'+optionId);
              console.log('2. pdp-option-'+i+': '+$optionObj.val());
              if ( $optionObj.data('option') == 'diopter' ) {
                optionId = optionId + '-right';
              }
              valTitle.push($addToCartForm.find('.'+optionId).val());
            };
            variantId = $addToCartForm.find('.pdp-variants-list option[data-title="'+valTitle.join(' / ')+'"]').val();

            queueForAdd.push({variantId: variantId, qty: addQty});
          }
          
          console.log('queueForAdd:');
          console.table(queueForAdd);

          addToBag(queueForAdd);
          
          return false;
          break;
          
        case 'normal':
        default:
          //$addToCartForm.find('#pdp-selected-variant').val($('.pdp-variants-list option').first().attr('value'));
          themeOriginalAddToCartFormHandler($(this));
          return true;
          break;
      }
      
      
    });

  };
  
  var themeOriginalAddToCartFormHandler = function($this) {

      var $addToCartForm = $this.closest('form');
      var $addToCartInfo = $this.parent('.product_form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
        },
        success: function(item) {

          var itemDiscounts = item.discounts;
          var discountMessage = "";

          for (i=0; i < itemDiscounts.length; i++) {
            var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
            var title = itemDiscounts[i].title;
            discountMessage = '<span class="notification-discount"><b>Discount:</b> ' + title + ' (- <span class="money">' + amount + '</span>)</span>';
          }

          $addToCartBtn.find('span').text("Added").removeClass('zoomOut').addClass('fadeIn');

          if ($(window).width() <= 798) {
            var padding = [20, 10, 20, 0];
          } else {
            var padding = [20, 40, 20, 40];
          }

          window.setTimeout(function(){
	          var hasImage = true;

	          if (item.image !== null) {
				      hasImage = true;
	          } else {
	          	hasImage = false;
	          }

            $.fancybox.close();

            if (hasImage) {
	            $.fancybox($('<div class="container section cart_notification" style="width: inherit"><div class="three columns product_image"><img src="' + item.image.replace(/(\.[^.]*)$/, "_grande$1").replace('https:', '') + '" alt="' + htmlEncode(item.title) + '" /></div><div class="six columns cart_notification_content"><div class="view_cart"><a href="/cart">View Cart</a></div><h4><span class="icon-check"></span> Just Added</h4> <div><strong>' + item.title + '</strong></div><p>' + item.quantity + ' x ' + '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span> ' + discountMessage + ' </p><p><a class="action_button" id="checkout" href="/checkout">Checkout</a> &nbsp;<span class="continue_shopping">or <a href="javascript:$.fancybox.close();">Continue Shopping <span class="icon-right-arrow"></span></a></span></div></div>'), {padding: padding, wrapCSS: 'cart_notification'});
            } else {
	          	$.fancybox($('<div class="container section cart_notification" style="width: inherit"><div class="six columns cart_notification_content"><div class="view_cart"><a href="/cart">View Cart</a></div><h4><span class="icon-check"></span> Just Added</h4> <div><strong>' + item.title + '</strong></div><p>' + item.quantity + ' x ' + '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span> ' + discountMessage + ' </p><p><a class="action_button" id="checkout" href="/checkout">Checkout</a> &nbsp;<span class="continue_shopping">or <a href="javascript:$.fancybox.close();">Continue Shopping <span class="icon-right-arrow"></span></a></span></div></div>'), {padding: padding, wrapCSS: 'cart_notification'});
            }


            
              convertCurrencies();
            
          }, 500);

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
          }, 1000);

          $.getJSON("/cart.js", function(cart) {
            updateCartCount(cart);
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    };
  
  var addToBag = function(queueForAdd) {
    
    Shopify.queue = queueForAdd;
    var addToBagErrMsg = [];
    
    $(".pdp-add-error").addClass('hidden').find('pdp-add-erro-msg').html("");
    
    Shopify.moveAlong = function() {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
	    var data = 'id='+ request.variantId + '&quantity='+request.qty
	    $.ajax({
	      type: 'POST',
              url: '/cart/add.js',
	      dataType: 'json',
	      data: data,
	      success: function(res){
	        Shopify.moveAlong();
          },
          error: function(xhr, ajaxOptions, thrownError){
			addToBagErrMsg.push(xhr.responseJSON.description);
            if (Shopify.queue.length){
              
              Shopify.moveAlong();
            } else {
              //$('.js-form-add-to-cart').find('.js-add-to-cart-submit').button('reset');
              setAddToBagReset();
              if (addToBagErrMsg.length) {
                $(".pdp-add-error").removeClass('hidden').find('.pdp-add-error-msg').html(addToBagErrMsg.join("<br />"));
              }
            }
	      }
        });
      } else {
        console.log('queue clean');
        
        setAddToBagSuccess($('.js-add-to-cart-submit'));
        
        Naturali.globalVal.checkoutDeferredObj.resolve();
        
        if (addToBagErrMsg.length) {
          $(".pdp-add-error").removeClass('hidden').find('.pdp-add-error-msg').html(addToBagErrMsg.join("<br />"));
        }

        $.getJSON("/cart.js", function(cart) {
          updateCartCount(cart);
        });

        switch( $('.js-form-add-to-cart').data('mode') ){
          case 'quick-checkout':

            NaturaliTracking.trackEvent({
              eventCategory: 'HP: Quick PDP',
              eventAction: 'Click - Quick Checkout',
              eventLabel: ''
            });

            location.href="/cart";
            break;
          case 'checkout':

            NaturaliTracking.trackEvent({
              eventCategory: 'PDP',
              eventAction: 'Click - Checkout',
              eventLabel: ''
            });

            location.href="/cart";
            break;
          case 'quick-add-to-cart':
            NaturaliTracking.trackEvent({
              eventCategory: 'HP: Quick PDP',
              eventAction: 'Click - Add to cart',
              eventLabel: ''
            });

            $('.popupPDP-container').modal('hide');
            $(document).trigger('cart.update');

            break;
          default:

            NaturaliTracking.trackEvent({
              eventCategory: 'PDP',
              eventAction: 'Click - Add to cart',
              eventLabel: ''
            });

            $(document).trigger('cart.update');
            break;
        }

        $('.js-pdp-goToCheckout').removeClass('hide');
      }
    };
	Shopify.moveAlong();
  };
  
  return {
    init: init,
    globalVal: {}
  };
}();


var NaturaliCart = NaturaliCart || {};
NaturaliCart = function(){

  var init = function(){
//    $(document).on('cart.update', updateCart);

  };


  
  return {
    init: init
  }
}();

var NaturaliPDP = NaturaliPDP || {};
NaturaliPDP = function(){

  var data = {};
  
  var pdpInit = function(){
    console.log('pdpInit');
    initQtyPicker();
    initDiopterPicker();
    updateOptionEnableness($('.js-product-qty'));
    applyBehaviorTracking();
  };
  
  var initQtyPicker = function() {
    $(document).on('change', '.js-product-qty', function(e){
      console.log('.js-product-qty changed');
      updateOptionEnableness($(this));
      updatePrice();
    });
    updatePrice();
  };
  
  var initDiopterPicker = function() {
    $('.pdp-option-1, .pdp-option-1-right').on('change', function(){
      var $form = $(this).closest('form');
      updateQtyHint($form);
    });
  };
  
  var applyBehaviorTracking = function() {

    if ( $('.js-color-select').length > 0 ) {
      data.currentProduct = $('.js-color-select').val();
    } else {
      data.currentProduct = location.pathname;
    }
    data.changedProperties = false;
    // log change color
    $('.js-color-select').on('change', function(){
      var changedValue = $(this).val();
      NaturaliTracking.trackEvent({
        eventCategory: 'PDP',
        eventAction: 'Change Color - ' + data.currentProduct,
        eventLabel: changedValue
      });

      // log any properties change before color change
      NaturaliTracking.trackEvent({
        eventCategory: 'PDP',
        eventAction: 'Changed properties before color',
        eventLabel: data.changedProperties
      });
    });

    // log change diopter
    $('.product-customizer-select-wrap select[name^="properties"]').on('change', function(){
      data.changedProperties = true;
      NaturaliTracking.trackEvent({
        eventCategory: 'PDP',
        eventAction: 'Change ' + $(this).attr('name') + ' - ' + data.currentProduct,
        eventLabel: $(this).find('option:selected').text()
      });
    });

    $('#AddToCartText').on('click', function(){
      data.changedProperties = true;
      NaturaliTracking.trackEvent({
        eventCategory: 'PDP',
        eventAction: 'Click',
        eventLabel: 'Add to cart'
      });
    });

    // log PDP SNS sharing
    $('.social-sharing a').on('click', function(){
      NaturaliTracking.trackEvent({
        eventCategory: 'PDP',
        eventAction: 'Click',
        eventLabel: $(this).attr('class')
      });
    });

    // log click related PDP
    $('.product-detail-related-product a').on('click', function(){
      NaturaliTracking.trackEvent({
        eventCategory: 'PDP',
        eventAction: 'Click',
        eventLabel: 'Related Products'
      });
    });

  };
  
  var updateOptionEnableness = function($elm) {
	
    var qty = $elm.val(),
      isChangeDiopter = $elm.data('change-diopter'),
      $optionToBeDisabled = $('.select[data-ref="right-diopter"]');

    if(isChangeDiopter!==false) {
      if( qty == '1' ) {
        $optionToBeDisabled.toggleClass('hidden',true);
        $optionToBeDisabled.find('.multi_select').attr('disabled', true);

      } else {
        $optionToBeDisabled.removeClass('hidden');
        $optionToBeDisabled.find('.multi_select').removeAttr('disabled');
      }
    }
    
    updateQtyHint($elm.closest('form'));
  };
  
  var updateQtyHint = function($form) {
    var msg = "",
        qty = parseInt( $form.find('.js-product-qty').val() ),
        $qtyHintMsgTpl = $form.find('.js-qty-selected-hint'),
        msgTpl = $qtyHintMsgTpl.data('msg-tpl'),
        productName = $qtyHintMsgTpl.data('product-name'),
        pdpDiopter1Val = $form.find('.pdp-option-1').val(),
        pdpDiopter2Val = $form.find('.pdp-option-1-right').val();
    
    
    
    if( $qtyHintMsgTpl.length ){
    
      if ( qty === 1 ) {

        msg = msgTpl.replace('$0', qty);
        msg = msg.replace('$1', productName);
        msg = msg.replace('$2', pdpDiopter1Val);
        
//         var $variantDropdown = $('.product-description-bottom .pdp-variants-list');
//         var diopterPlainVal = pdpDiopter1Val.replace('-','').replace('.','');
//         var targetOptionVal = $variantDropdown.find('option').filter('[data-sku*="'+diopterPlainVal+'"]').val();
//         $variantDropdown.find('option').attr('selected',false);
//         $variantDropdown.find('option[value="'+targetOptionVal+'"]').attr('selected',true);
        updateHiddenVariantForDynamicCheckout(pdpDiopter1Val);
        
        showDynamicCheckoutBtn(true, false);

      } else {
        
        
        
        if( pdpDiopter1Val == pdpDiopter2Val ) {
          
          if(qty<3) {
//             var $variantDropdown = $('.product-description-bottom .pdp-variants-list');
//             var diopterPlainVal = pdpDiopter1Val.replace('-','').replace('.','');
//             var targetOptionVal = $variantDropdown.find('option').filter('[data-sku*="'+diopterPlainVal+'"]').val();
//             $variantDropdown.find('option').attr('selected',false);
//             $variantDropdown.find('option[value="'+targetOptionVal+'"]').attr('selected',true);
            updateHiddenVariantForDynamicCheckout(pdpDiopter1Val);
            

            showDynamicCheckoutBtn(true, false);
          } else {
            showDynamicCheckoutBtn(false, false);
          }

          msg = msgTpl.replace('$0', qty);
          msg = msg.replace('$1', productName);
          msg = msg.replace('$2', pdpDiopter1Val);

        } else {
          
          if(qty<3) {
            showDynamicCheckoutBtn(false, true);
          } else {
            showDynamicCheckoutBtn(false, false);
          }
          msg = msgTpl.replace('$0', qty / 2);
          msg = msg.replace('$1', productName);
          msg = msg.replace('$2', pdpDiopter1Val);

          msg += "<br />";

          msg += msgTpl.replace('$0', qty / 2);
          msg = msg.replace('$1', productName);
          msg = msg.replace('$2', pdpDiopter2Val);
        }
      }

      $qtyHintMsgTpl.html( msg );
      
    }
  };
  
  var updateHiddenVariantForDynamicCheckout = function(diopterVal){
    console.log('updateHiddenVariantForDynamicCheckout: '+diopterVal );
    if ( typeof diopterVal === 'undefined') return false;
    var $variantDropdown = $('.product-description-bottom .pdp-variants-list');
    var diopterPlainVal = diopterVal.replace('-','').replace('.','');
    var targetOptionVal = $variantDropdown.find('option').filter('[data-sku*="'+diopterPlainVal+'"]').val();
    $variantDropdown.find('option').attr('selected',false);
    $variantDropdown.find('option[value="'+targetOptionVal+'"]').attr('selected',true);
  };
  
  var showDynamicCheckoutBtn = function(showShopifyBtn, showBuyNow) {
    $('.shopify-payment-button').toggleClass('hidden', !showShopifyBtn);
    if ( $('.js-buy-now').data('volumn-discount-in-cart') === false ) {
      $('.js-buy-now').toggleClass('hidden', !showBuyNow);
    }
    
    var remainSingleBtn = $('.shopify-payment-button').hasClass('hidden') && $('.js-buy-now').hasClass('hidden');

    $('.purchase-details__buttons button').first().toggleClass('action_button--secondary', !remainSingleBtn);

  };


  var updatePrice = function( selectedProductId ) {

    // new update price approach
    var $productPrice = $('.js-pdp-product-price'),
        $productComparePrice = $('.js-pdp-product-compare-price'),
        singleProductPrice = parseInt($productPrice.data('price')) * 100,
        singleProductComparePrice = parseInt($productComparePrice.data('price')) * 100,
        qty = parseInt($('.js-product-qty').val()),
        newPrice = 0,
        comparePrice = 0,
        newConvertedPrice = 0,
        newConvertedPriceHtml = "",
        newConvertedComparePrice = 0,
        newConvertedComparePriceHtml = "",
        discountHTML = '';;

    newPrice = parseFloat((singleProductPrice * qty).toFixed(1));
    comparePrice = parseFloat((singleProductComparePrice * qty).toFixed(1));

    if ( typeof NaturaliInfo !== "undefined" && 
        typeof NaturaliInfo.discountModel !== "undefined" && 
        NaturaliInfo.discountModel.length > 0 ) {
      NaturaliInfo.discountModel.forEach(function(discountObj){
        if ( qty === discountObj.qty ) {
          newPrice = parseFloat((singleProductPrice * qty * (1-discountObj.discount)).toFixed(1));
          comparePrice = parseFloat((singleProductPrice * qty).toFixed(1));
          console.log(newPrice);

          comparePrice = Currency.convert(comparePrice, defaultCurrency, Currency.currentCurrency);
          discountHTML = Currency.formatMoney( comparePrice, Currency.money_with_currency_format[Currency.currentCurrency]);
        }
      });


    } else {
      if ( $productPrice.data('price') != $productComparePrice.data('price') ) {
        
      }
    }

    newConvertedPrice = Currency.convert(newPrice, defaultCurrency, Currency.currentCurrency);
    newConvertedPriceHtml = Currency.formatMoney( newConvertedPrice, Currency.money_with_currency_format[Currency.currentCurrency]);
    newConvertedComparePrice = Currency.convert(comparePrice, defaultCurrency, Currency.currentCurrency);
    newConvertedComparePriceHtml = Currency.formatMoney( newConvertedComparePrice, Currency.money_with_currency_format[Currency.currentCurrency]);

    $productPrice.html( newConvertedPriceHtml );
    $productComparePrice.html( newConvertedComparePriceHtml );

    if ( newPrice != comparePrice ) {
      $productComparePrice.removeClass('hidden').find('.money')
          .html( discountHTML );
    } else {
      $productComparePrice.addClass('hidden');
    }


  };
  
  return {
    init: pdpInit,
    showDynamicCheckoutBtn: showDynamicCheckoutBtn
  }
}();

var NaturaliTracking = NaturaliTracking || {};
NaturaliTracking = function(){
  
  var trackEvent = function(data){
    ga('send', {
      hitType: 'event',
      eventCategory: data.eventCategory,
      eventAction: data.eventAction,
      eventLabel: data.eventLabel
    });
  };

  return {
    trackEvent: trackEvent
  }
}();



var NaturaliMisc = NaturaliMisc || {};
NaturaliMisc = function(){

  var init = function () {
    
    initAccordion();

  };
  
  var initAccordion = function(){

    $('.tab-section').tabCollapse({
      tabsClass: 'mobile_hidden',
      accordionClass: 'desktop_hidden'
    });

  };
  
  return {
    init: init
  }
}();


$(function(){
  Naturali.init();
  NaturaliCart.init();
  NaturaliPDP.init();
  NaturaliMisc.init();

});



+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.5'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

!function ($) {

    "use strict";

    // TABCOLLAPSE CLASS DEFINITION
    // ======================

    var TabCollapse = function (el, options) {
        this.options   = options;
        this.$tabs  = $(el);

        this._accordionVisible = false; //content is attached to tabs at first
        this._initAccordion();
        this._checkStateOnResize();


        // checkState() has gone to setTimeout for making it possible to attach listeners to
        // shown-accordion.bs.tabcollapse event on page load.
        // See https://github.com/flatlogic/bootstrap-tabcollapse/issues/23
        var that = this;
        setTimeout(function() {
          that.checkState();
        }, 0);
    };

    TabCollapse.DEFAULTS = {
        accordionClass: 'visible-xs',
        tabsClass: 'hidden-xs',
        accordionTemplate: function(heading, groupId, parentId, active) {
            return  '<div class="panel panel-default">' +
                    '   <div class="panel-heading">' +
                    '      <h4 class="panel-title">' +
                    '      </h4>' +
                    '   </div>' +
                    '   <div id="' + groupId + '" class="panel-collapse collapse ' + (active ? 'in' : '') + '">' +
                    '       <div class="panel-body js-tabcollapse-panel-body">' +
                    '       </div>' +
                    '   </div>' +
                    '</div>'

        }
    };

    TabCollapse.prototype.checkState = function(){
        if (this.$tabs.is(':visible') && this._accordionVisible){
            this.showTabs();
            this._accordionVisible = false;
        } else if (this.$accordion.is(':visible') && !this._accordionVisible){
            this.showAccordion();
            this._accordionVisible = true;
        }
    };

    TabCollapse.prototype.showTabs = function(){
        var view = this;
        this.$tabs.trigger($.Event('show-tabs.bs.tabcollapse'));

        var $panelHeadings = this.$accordion.find('.js-tabcollapse-panel-heading').detach();

        $panelHeadings.each(function() {
            var $panelHeading = $(this),
            $parentLi = $panelHeading.data('bs.tabcollapse.parentLi');

            var $oldHeading = view._panelHeadingToTabHeading($panelHeading);

            $parentLi.removeClass('active');
            if ($parentLi.parent().hasClass('dropdown-menu') && !$parentLi.siblings('li').hasClass('active')) {
                $parentLi.parent().parent().removeClass('active');
            }

            if (!$oldHeading.hasClass('collapsed')) {
                $parentLi.addClass('active');
                if ($parentLi.parent().hasClass('dropdown-menu')) {
                    $parentLi.parent().parent().addClass('active');
                }
            } else {
                $oldHeading.removeClass('collapsed');
            }

            $parentLi.append($panelHeading);
        });

        if (!$('li').hasClass('active')) {
            $('li').first().addClass('active')
        }

        var $panelBodies = this.$accordion.find('.js-tabcollapse-panel-body');
        $panelBodies.each(function(){
            var $panelBody = $(this),
                $tabPane = $panelBody.data('bs.tabcollapse.tabpane');
            $tabPane.append($panelBody.contents().detach());
        });
        this.$accordion.html('');

        if(this.options.updateLinks) {
            var $tabContents = this.getTabContentElement();
            $tabContents.find('[data-toggle-was="tab"], [data-toggle-was="pill"]').each(function() {
                var $el = $(this);
                var href = $el.attr('href').replace(/-collapse$/g, '');
                $el.attr({
                    'data-toggle': $el.attr('data-toggle-was'),
                    'data-toggle-was': '',
                    'data-parent': '',
                    href: href
                });
            });
        }

        this.$tabs.trigger($.Event('shown-tabs.bs.tabcollapse'));
    };

    TabCollapse.prototype.getTabContentElement = function(){
        var $tabContents = $(this.options.tabContentSelector);
        if($tabContents.length === 0) {
            $tabContents = this.$tabs.siblings('.tab-content');
        }
        return $tabContents;
    };

    TabCollapse.prototype.showAccordion = function(){
        this.$tabs.trigger($.Event('show-accordion.bs.tabcollapse'));

        var $headings = this.$tabs.find('li:not(.dropdown) [data-toggle="tab"], li:not(.dropdown) [data-toggle="pill"]'),
            view = this;
        $headings.each(function(){
            var $heading = $(this),
                $parentLi = $heading.parent();
            $heading.data('bs.tabcollapse.parentLi', $parentLi);
            view.$accordion.append(view._createAccordionGroup(view.$accordion.attr('id'), $heading.detach()));
        });

        if(this.options.updateLinks) {
            var parentId = this.$accordion.attr('id');
            var $selector = this.$accordion.find('.js-tabcollapse-panel-body');
            $selector.find('[data-toggle="tab"], [data-toggle="pill"]').each(function() {
                var $el = $(this);
                var href = $el.attr('href') + '-collapse';
                $el.attr({
                    'data-toggle-was': $el.attr('data-toggle'),
                    'data-toggle': 'collapse',
                    'data-parent': '#' + parentId,
                    href: href
                });
            });
        }

        this.$tabs.trigger($.Event('shown-accordion.bs.tabcollapse'));
    };

    TabCollapse.prototype._panelHeadingToTabHeading = function($heading) {
        var href = $heading.attr('href').replace(/-collapse$/g, '');
        $heading.attr({
            'data-toggle': 'tab',
            'href': href,
            'data-parent': ''
        });
        return $heading;
    };

    TabCollapse.prototype._tabHeadingToPanelHeading = function($heading, groupId, parentId, active) {
        $heading.addClass('js-tabcollapse-panel-heading ' + (active ? '' : 'collapsed'));
        $heading.attr({
            'data-toggle': 'collapse',
            'data-parent': '#' + parentId,
            'href': '#' + groupId
        });
        return $heading;
    };

    TabCollapse.prototype._checkStateOnResize = function(){
        var view = this;
        $(window).resize(function(){
            clearTimeout(view._resizeTimeout);
            view._resizeTimeout = setTimeout(function(){
                view.checkState();
            }, 100);
        });
    };


    TabCollapse.prototype._initAccordion = function(){
        var randomString = function() {
            var result = "",
                possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for( var i=0; i < 5; i++ ) {
                result += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return result;
        };

        var srcId = this.$tabs.attr('id'),
            accordionId = (srcId ? srcId : randomString()) + '-accordion';

        this.$accordion = $('<div class="panel-group ' + this.options.accordionClass + '" id="' + accordionId +'"></div>');
        this.$tabs.after(this.$accordion);
        this.$tabs.addClass(this.options.tabsClass);
        this.getTabContentElement().addClass(this.options.tabsClass);
    };

    TabCollapse.prototype._createAccordionGroup = function(parentId, $heading){
        var tabSelector = $heading.attr('data-target'),
            active = $heading.data('bs.tabcollapse.parentLi').is('.active');

        if (!tabSelector) {
            tabSelector = $heading.attr('href');
            tabSelector = tabSelector && tabSelector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
        }

        var $tabPane = $(tabSelector),
            groupId = $tabPane.attr('id') + '-collapse',
            $panel = $(this.options.accordionTemplate($heading, groupId, parentId, active));
        $panel.find('.panel-heading > .panel-title').append(this._tabHeadingToPanelHeading($heading, groupId, parentId, active));
        $panel.find('.panel-body').append($tabPane.contents().detach())
            .data('bs.tabcollapse.tabpane', $tabPane);

        return $panel;
    };



    // TABCOLLAPSE PLUGIN DEFINITION
    // =======================

    $.fn.tabCollapse = function (option) {
        return this.each(function () {
            var $this   = $(this);
            var data    = $this.data('bs.tabcollapse');
            var options = $.extend({}, TabCollapse.DEFAULTS, $this.data(), typeof option === 'object' && option);

            if (!data) $this.data('bs.tabcollapse', new TabCollapse(this, options));
        });
    };

    $.fn.tabCollapse.Constructor = TabCollapse;


}(window.jQuery);

+function(a) {
    "use strict";
    function b(b) {
        var c, d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");
        return a(d)
    }
    function c(b) {
        return this.each(function() {
            var c = a(this)
              , e = c.data("bs.collapse")
              , f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
            !e && f.toggle && /show|hide/.test(b) && (f.toggle = !1),
            e || c.data("bs.collapse", e = new d(this,f)),
            "string" == typeof b && e[b]()
        })
    }
    var d = function(b, c) {
        this.$element = a(b),
        this.options = a.extend({}, d.DEFAULTS, c),
        this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'),
        this.transitioning = null,
        this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger),
        this.options.toggle && this.toggle()
    };
    d.VERSION = "3.3.5",
    d.TRANSITION_DURATION = 350,
    d.DEFAULTS = {
        toggle: !0
    },
    d.prototype.dimension = function() {
        var a = this.$element.hasClass("width");
        return a ? "width" : "height"
    }
    ,
    d.prototype.show = function() {
        if (!this.transitioning && !this.$element.hasClass("in")) {
            var b, e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
            if (!(e && e.length && (b = e.data("bs.collapse"),
            b && b.transitioning))) {
                var f = a.Event("show.bs.collapse");
                if (this.$element.trigger(f),
                !f.isDefaultPrevented()) {
                    e && e.length && (c.call(e, "hide"),
                    b || e.data("bs.collapse", null));
                    var g = this.dimension();
                    this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0),
                    this.$trigger.removeClass("collapsed").attr("aria-expanded", !0),
                    this.transitioning = 1;
                    var h = function() {
                        this.$element.removeClass("collapsing").addClass("collapse in")[g](""),
                        this.transitioning = 0,
                        this.$element.trigger("shown.bs.collapse")
                    };
                    if (!a.support.transition)
                        return h.call(this);
                    var i = a.camelCase(["scroll", g].join("-"));
                    this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])
                }
            }
        }
    }
    ,
    d.prototype.hide = function() {
        if (!this.transitioning && this.$element.hasClass("in")) {
            var b = a.Event("hide.bs.collapse");
            if (this.$element.trigger(b),
            !b.isDefaultPrevented()) {
                var c = this.dimension();
                this.$element[c](this.$element[c]())[0].offsetHeight,
                this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1),
                this.$trigger.addClass("collapsed").attr("aria-expanded", !1),
                this.transitioning = 1;
                var e = function() {
                    this.transitioning = 0,
                    this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
                };
                return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this)
            }
        }
    }
    ,
    d.prototype.toggle = function() {
        this[this.$element.hasClass("in") ? "hide" : "show"]()
    }
    ,
    d.prototype.getParent = function() {
        return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function(c, d) {
            var e = a(d);
            this.addAriaAndCollapsedClass(b(e), e)
        }, this)).end()
    }
    ,
    d.prototype.addAriaAndCollapsedClass = function(a, b) {
        var c = a.hasClass("in");
        a.attr("aria-expanded", c),
        b.toggleClass("collapsed", !c).attr("aria-expanded", c)
    }
    ;
    var e = a.fn.collapse;
    a.fn.collapse = c,
    a.fn.collapse.Constructor = d,
    a.fn.collapse.noConflict = function() {
        return a.fn.collapse = e,
        this
    }
    ,
    a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(d) {
        var e = a(this);
        e.attr("data-target") || d.preventDefault();
        var f = b(e)
          , g = f.data("bs.collapse")
          , h = g ? "toggle" : e.data();
        c.call(f, h)
    })
}(jQuery);